/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cj_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. The conversion runs entirely in your browser; nothing is uploaded.`)
};

const es_cj_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. La conversión se ejecuta completamente en tu navegador; nada se carga.`)
};

const de_cj_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Die Konvertierung läuft vollständig in deinem Browser; es wird nichts hochgeladen.`)
};

const nl_cj_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. De conversie vindt volledig in uw browser plaats; er wordt niets geüpload.`)
};

const fr_cj_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. La conversion s'exécute entièrement dans votre navigateur ; rien n'est téléchargé.`)
};

const it_cj_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. La conversione viene eseguita completamente nel tuo browser; nulla viene caricato.`)
};

const pt_br2_cj_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A conversão funciona inteiramente no seu navegador; nada é enviado.`)
};

const pt_cj_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A conversão funciona inteiramente no seu navegador; nada é carregado.`)
};

const ja_cj_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。変換はブラウザ内で完全に実行され、何もアップロードされません。`)
};

const zh_cj_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。转换完全在你的浏览器中进行，不会上传任何数据。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cj_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cj_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cj_faq3_a", locale)
	if (locale === "en") return en_cj_faq3_a(inputs)
	if (locale === "es") return es_cj_faq3_a(inputs)
	if (locale === "de") return de_cj_faq3_a(inputs)
	if (locale === "nl") return nl_cj_faq3_a(inputs)
	if (locale === "fr") return fr_cj_faq3_a(inputs)
	if (locale === "it") return it_cj_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_cj_faq3_a(inputs)
	if (locale === "pt") return pt_cj_faq3_a(inputs)
	if (locale === "ja") return ja_cj_faq3_a(inputs)
	return zh_cj_faq3_a(inputs)
};